import { mergeProps, Show } from 'solid-js';
import IconLeft from '~/assets/images/tabs/left.svg?component-solid';
import IconRight from '~/assets/images/tabs/right.svg?component-solid';

export const ScrollArrow = (originProps: {
  direction: 'left' | 'right';
  visible: boolean;
  onClick: () => void;
  iconClass?: string;
  disabled?: boolean;
}) => {
  const props = mergeProps({ iconClass: 'text-essential-colour', disabled: false }, originProps);

  return (
    <Show when={props.visible}>
      <div
        class={`px-3 hover-allowed:hover:cursor-pointer ${props.disabled ? 'pointer-events-none opacity-40' : ''}`}
        onClick={props.disabled ? undefined : props.onClick}>
        {props.direction === 'left' ? <IconLeft class={props.iconClass} /> : <IconRight class={props.iconClass} />}
      </div>
    </Show>
  );
};
